import { merge } from 'lodash';
import { getDIVEGirderConfig } from 'platform/web-girder/api';
const girderModule = {
    namespaced: true,
    state: {
        girderState: {},
    },
    mutations: {
        setDIVEGirderConfig(state, data) {
            state.girderState = merge(state.girderState, data);
        },
    },
    actions: {
        async loadDIVEGirderConfig({ commit }) {
            commit('setDIVEGirderConfig', (await getDIVEGirderConfig()).data);
        },
    },
};
export default girderModule;
